import enhance from './enhance.js';

export default { enhance };
